import React from 'react';
import ReactDOM from 'react-dom/client';
import { installClientErrorTelemetry } from '@smallbiz/ui-primitives';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import './styles/globals.css';

// Note: Theme initialization is handled by inline script in index.html
// to prevent flash of unstyled content. No need to duplicate here.

// EPIC #5310 / #5309 — install the client error funnel once, before render, so
// uncaught errors + same-origin /api 5xx join their server trace by trace_id.
installClientErrorTelemetry();

// EPIC #2472 — a small hello for anyone who opens the console. Browser-only,
// runs once per page load, and never throws (a console flourish is never
// worth breaking the app over).
function greetConsole(): void {
  try {
    if (typeof window === 'undefined' || typeof console === 'undefined') return;
    const w = window as typeof window & { __sbiConsoleGreeted?: boolean };
    if (w.__sbiConsoleGreeted) return;
    w.__sbiConsoleGreeted = true;

    console.log(
      '%cSmallBiz Innovation',
      'font-size:16px;font-weight:700;color:#1167f1;'
    );
    console.log('You opened the console. That is the curious kind, and we like curious.');
    console.log('Meet the team: /team · Credits: /humans.txt · Say hello: /contact');
  } catch {
    // Never let this break the app.
  }
}

greetConsole();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ErrorBoundary component="www-app" variant="app">
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
